import { Component, OnInit, Input, TemplateRef } from '@angular/core';

@Component({
    selector: 'app-search-section',
    templateUrl: './search-section.component.html',
    styleUrls: ['./search-section.component.css']
})
export class SearchSectionComponent implements OnInit {
    @Input() template: TemplateRef<any>;

    constructor() { }

    ngOnInit() {
    }
}
